import { create } from 'zustand';
import { ProductSchemaT } from '../components/forms/AddNewProduct';
// import { AddProductSchemaT } from '../types/schema/productSchema';

type ProductRequestStore = {
  currentProduct: ProductSchemaT | null;
  setCurrentProduct: (product: ProductSchemaT | null) => void;
  clearCurrentProduct: () => void;
};

const useProductRequestStore = create<ProductRequestStore>(set => ({
  currentProduct: null,
  setCurrentProduct: product => set({ currentProduct: product }),
  clearCurrentProduct: () => set({ currentProduct: null }),
}));

export default useProductRequestStore;
